@let showFloatingToolbar = showFloatingToolbar$ | async;
<div class="container">
    @if ((showFixedToolbar$ | async) === true) {
      <pcp-slide-sync-toolbar
        [direction]="direction"
        [class.hidden]="(isShowingIntegratedApp$ | async) === true"
        [class.fixed]="useFixedToolbar"
        >
        <ng-content select="[toolbar-content]"></ng-content>
      </pcp-slide-sync-toolbar>
    }

    <div class="content" pcpResized (pcpResized)="onContentResized($event)">
      @let scale = svgScale();
      @if (showToggleFullscreen() && scale !== null) {
        <pcp-slide-sync-fullscreen-button
          (toggleFullscreen)="fullscreenButtonClicked.emit()"
          [scale]="scale"
          [isFullscreen]="isPreviewInFullscreen()"
          />
      }

      @for (layer of layers; track layer) {
        @let primarySlide = layer.slide$ | async;
        @let primarySlideTypeCategory = layer.slideTypeCategory$ | async;
        @let primarySlideIsFavorite = layer.slideIsFavorite$ | async;
        @let isLessonPaused = isLessonPaused$ | async;
        <!-- Primary slide -->
        @if (
          primarySlide &&
          primarySlideTypeCategory &&
          primarySlideTypeCategory !== 'none'
          ) {
                  <app-slide-preview-element
                    [svgScale]="svgScale()"
                    [suffix]="layer.suffix"
                    [isPresentationScreen]="isPresentationScreen"
                    [disableElementUsage]="disableElementUsage"
                                    [emitHtmlElementModifications]="
                                        emitHtmlElementModifications
                                    "
                    [currentSlide]="primarySlide"
                    [slideTypeCategory]="primarySlideTypeCategory!"
                    [perceptionRevealed]="(layer.perceptionRevealed$ | async) === true"
                    [perceptionShowEpoch]="(layer.perceptionShowEpoch$ | async) ?? 0"
                    [isFavorite]="primarySlideIsFavorite === true"
                    [hidden]="(layer.isHidden$ | async) === true"
                                    [isOpenedFromHotspot]="
                                        (layer.isOpenedFromHotspot$ | async) ===
                                        true
                                    "
                    [drawingTool]="drawingTool$ | async"
                    [isLessonPaused]="isLessonPaused ?? false"
                    [enetToken]="(enetToken$ | async) ?? undefined"
                    [loginCode]="(loginCode$ | async) ?? 'XXXXX'"
                                    [presentationId]="
                                        (presentationId$ | async) ?? undefined
                                    "
                    [favoritesDisabled]="(layer.favoritesDisabled$ | async) === true"
                    [isPresentationStarted]="(isPresentationStarted$ | async) ?? false"
                    [resetDynamicContent$]="layer.resetDynamicContent$"
                    [commandStream$]="layer.mutationCommandStream() ?? undefined"
                    [showPrevBookpagePageLink]="(layer.showPrevBookpagePageLink$ | async) === true"
                    [showNextBookpagePageLink]="(layer.showNextBookpagePageLink$ | async) === true"
                    (prevBookpageClicked)="onPrevBookpageClicked(primarySlide)"
                    (nextBookpageClicked)="onNextBookpageClicked(primarySlide)"
                    (hotspotClick)="layer.onHotspotClick($event, primarySlide)"
                    (perceptionImageRevealed)="layer.onPerceptionImageRevealed(primarySlide)"
                    (domModified)="layer.onSlideMutated(primarySlide, $event)"
                    (rubberElementInteraction)="layer.onCanvasMutated(primarySlide, $event)"
                                    (videoStartedPlaying)="
                                        layer.onVideoStartedPlaying(
                                            $event,
                                            primarySlide
                                        )
                                    "
                    (videoPaused)="layer.onVideoPaused($event, primarySlide)"
                    (videoLoaded)="layer.onVideoLoaded($event, primarySlide)"
                                    (seekedToPosition)="
                                        layer.onVideoSeekedToPosition(
                                            $event,
                                            primarySlide
                                        )
                                    "
                    (videoEnded)="layer.onVideoEnded($event, primarySlide)"
                    (showVideoForQuestionElement)="layer.onStartVideoInVideoQuestion($event)"
                    (addToFavoritesClicked)="addToFavorites($event)"
                    [svgTextboardPageNumber]="(layer.slidePageNumber$ | async) ?? 1"
                                    (svgTextboardPageNumberChanged)="
                                        layer.onSvgTextboardPageNumberChanged(
                                            $event
                                        )
                                    "
                  ></app-slide-preview-element>
        }
        <!-- TODO: output Event "slideHasBeenRendered"? Would make it possible to append the mutation observer from an effect -->
      }

      @let showFallbackImage = showFallbackImage$ | async;
      <!-- Static pause / fallback image (no slide selected, or lesson paused). -->
      @if (showFallbackImage === true) {
        <div id="pause-screen-image">
          @if (pauseImageUrl$ | async; as pauseImageUrl) {
            <pcp-pause-image [imageUrl]="pauseImageUrl" />
          }
        </div>
      }

          @if (
            isPresentationScreen &&
            (navigationPreviewEnabled | async) === true) {
            @if (glassTheme()) {
              <pcp-next-slides-preview-glassmorphic
                [class.hidden]="showFallbackImage === true"
                [showFloatingToolbar]="showFloatingToolbar ?? false"
                [isFloatingToolbarOpened]="isFloatingToolbarOpened()"
              >
                <!-- the beamer's floating-toolbar buttons, passed on to the floating toolbar inside the nav -->
                <ng-container ngProjectAs="[floating-toolbar-content]">
                  <ng-content select="[floating-toolbar-content]"></ng-content>
                </ng-container>
              </pcp-next-slides-preview-glassmorphic>
            } @else {
              <!-- classic nav (TUT beamer): no floating toolbar (see `floatingToolbar`) -->
              <pcp-next-slides-preview
                [class.hidden]="showFallbackImage === true"
              ></pcp-next-slides-preview>
            }
      }
    </div>
</div>
